import { useGlobalContext } from "../../context/GlobalContext";

export const useModals = () => {
  const { updateData } = useGlobalContext();

  const setOpenGenerateApiKey = (): void => {
    updateData({ openGenerateApiKey: true });
  };

  const setOpenIframeKeyGeneration = (): void => {
    updateData({ openIframeKeyGeneration: true });
  };

  const setCloseIframeKeyGeneration = (): void => {
    updateData({ openIframeKeyGeneration: false });
  };

  const setCloseGenerateApiKey = (): void => {
    updateData({ openGenerateApiKey: false });
  };

  const setOpenStaticQRCode = (): void => {
    updateData({ openStaticQRCode: true });
  };

  const setDisbursementSettings = (): void => {
    updateData({ openDisbursementSettings: true });
  };

  const setCloseStaticQRCode = (): void => {
    updateData({ openStaticQRCode: false });
  };

  const setOpenUSSDHealthCheck = (): void => {
    updateData({ openUSSDHealthCheck: true });
  };
  const setCloseUSSDHealthCheck = (): void => {
    updateData({ openUSSDHealthCheck: false });
  };

  const setOpenCheckPaymentStatus = (): void => {
    updateData({ openCheckPaymentStatus: true });
  };

  const setCloseCheckPaymentStatus = (): void => {
    updateData({ openCheckPaymentStatus: false });
  };

  const setOpenInterestStatement = (): void => {
    updateData({ openInterestStatement: true });
  };

  const setCloseInterestStatement = (): void => {
    updateData({ openInterestStatement: false });
  };

  const setOpenSettlementEligibilityReview = (): void => {
    updateData({ openSettlementEligibilityReview: true });
  };

  const setCloseSettlementEligibilityReview = (): void => {
    updateData({ openSettlementEligibilityReview: false });
  };

  return {
    setOpenGenerateApiKey,
    setCloseGenerateApiKey,
    setOpenStaticQRCode,
    setCloseStaticQRCode,
    setOpenIframeKeyGeneration,
    setCloseIframeKeyGeneration,
    setDisbursementSettings,
    setOpenUSSDHealthCheck,
    setCloseUSSDHealthCheck,
    setOpenCheckPaymentStatus,
    setCloseCheckPaymentStatus,
    setOpenInterestStatement,
    setCloseInterestStatement,
    setOpenSettlementEligibilityReview,
    setCloseSettlementEligibilityReview,
  };
};
